import { useSelector } from 'react-redux';
import { selectors as appConfigSelectors } from 'modules/appConfig';

import {
	ThemeProvider as UcThemeProvider,
	ThemeProviderProps as UcThemeProviderProps,
	CssBaseline,
} from '@liquidweb-dev/undercurrent';
import { Toaster } from '@liquidweb-dev/undercurrent/toast';
import liquidwebTheme from '@liquidweb-dev/undercurrent/themes/liquidweb';
import nexcessTheme from '@liquidweb-dev/undercurrent/themes/nexcess';

export type ThemeProviderProps = UcThemeProviderProps;

const ThemeProvider = ({ children, ...props }: ThemeProviderProps) => {
	const appConfig = useSelector(appConfigSelectors.getAppConfig);
	const theme = appConfig?.theme === 'nexcess' ? nexcessTheme : liquidwebTheme;

	return (
		<UcThemeProvider defaultMode="light" theme={theme} {...props}>
			<CssBaseline />
			{children}
			<Toaster />
		</UcThemeProvider>
	);
};

export default ThemeProvider;
